import { render } from "./GameSimpleListCard.vue?vue&type=template&id=76161984&scoped=true"
import script from "./GameSimpleListCard.vue?vue&type=script&lang=js"
export * from "./GameSimpleListCard.vue?vue&type=script&lang=js"

import "./GameSimpleListCard.vue?vue&type=style&index=0&id=76161984&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76161984"]])

export default __exports__